import { render, staticRenderFns } from "./FootprintTableList.vue?vue&type=template&id=8e44df8c&scoped=true&"
import script from "./FootprintTableList.vue?vue&type=script&lang=js&"
export * from "./FootprintTableList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e44df8c",
  null
  
)

export default component.exports